<template>
  <div>
    <div v-for="(item, index) in industrylist" :key="index">
      <!-- 一级 -->
      <el-checkbox-group v-model="item.labelparam1">
        <el-checkbox
          v-for="o in item.typelist"
          :key="o.id"
          :label="o.id"
          @change="industrycodechange1(o)"
        >
          <span>{{ o.industryName }}</span>
        </el-checkbox>
      </el-checkbox-group>

      <!-- 二级 -->
      <div class="child_label" v-if="item.codechildlist1.length">
        <span>二级标签:</span>
        <el-checkbox-group v-model="item.labelparam2">
          <el-checkbox
            v-for="i in item.codechildlist1"
            :key="i.id"
            :label="i.id"
            @change="industrycodechangechild(i)"
            >{{ i.industryName }}</el-checkbox
          >
        </el-checkbox-group>
      </div>

      <!-- 三级 -->
      <div class="child_label" v-if="item.childlist.length">
        <span>三级标签:</span>
        <el-checkbox-group v-model="item.labelparam3">
          <el-checkbox
            v-for="el in item.childlist"
            :key="el.id"
            :label="el.id"
            @change="industrycodechangechil4(el)"
            >{{ el.industryName }}</el-checkbox
          >
        </el-checkbox-group>
      </div>

      <!-- 四级 -->
      <div class="child_label" v-if="item.childlist4.length">
        <span>四级标签:</span>
        <el-checkbox-group v-model="item.labelparam4">
          <el-checkbox
            v-for="els in item.childlist4"
            :key="els.id"
            :label="els.id"
            @change="industrycodechangechil5(els)"
            >{{ els.industryName }}</el-checkbox
          >
        </el-checkbox-group>
      </div>

      <!-- 五级 -->
      <div class="child_label" v-if="item.childcode5.length">
        <span>五级标签:</span>
        <el-checkbox-group v-model="item.labelparam5">
          <el-checkbox
            v-for="item in item.childcode5"
            :key="item.id"
            :label="item.id"
            @change="industryparamchange5(item)"
            >{{ item.industryName }}</el-checkbox
          >
        </el-checkbox-group>
      </div>

      <!-- 六级 -->
      <div class="child_label" v-if="item.childcode6.length">
        <span>六级标签:</span>
        <el-checkbox-group v-model="item.labelparam6">
          <el-checkbox
            v-for="item in item.childcode6"
            :key="item.id"
            :label="item.id"
            @change="industryparamchange6(item)"
            >{{ item.industryName }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
import { getLabel } from "@/api/Sceneknowledge.js";
export default {
  name: "IndustryLabelGroup",
  props: {
    industrylist: {
      type: Array,
      required: true,
    },
  },
  computed: {
    personData() {
      return this.$route.query.id;
    },
  },
  data() {
    return {
      apiList: [],
    };
  },
  mounted() {
    if (this.personData) {
      this.getLabel();
    }
  },
  methods: {
    //查询国民经济标签组
    async getLabel() {
      const res = await getLabel({ id: this.personData });
      if (res.code == 200) {
        this.apiList = res.data;
        this.echoLabels(
          this.apiList.map((i) => i.labelId),
          this.industrylist
        );
      }
    },
    echoLabels(labelIds = [], industrylist) {
      if (!industrylist?.length) return;

      /* 1️⃣ 拍平 + 补 level */
      const flatMap = {};
      const dfs = (arr, lv = 1) => {
        arr.forEach((n) => {
          flatMap[n.id] = n;
          n.level = lv;
          if (n.childNode?.length) dfs(n.childNode, lv + 1);
        });
      };
      dfs(industrylist[0].typelist);

      /* 2️⃣ 清空旧数据 */
      const one = industrylist[0];
      [
        "labelparam1",
        "labelparam2",
        "labelparam3",
        "labelparam4",
        "labelparam5",
        "labelparam6",
      ].forEach((k) => (one[k] = []));
      [
        "codechildlist1",
        "childlist",
        "childlist4",
        "childcode5",
        "childcode6",
      ].forEach((k) => (one[k] = []));

      /* 3️⃣ 回显勾选 & 展开直接子级 */
      const childKeyMap = {
        1: "codechildlist1",
        2: "childlist",
        3: "childlist4",
        4: "childcode5",
        5: "childcode6",
      };

      labelIds.forEach((id) => {
        const node = flatMap[id];
        if (!node) return;

        /* 勾选自身 */
        one[`labelparam${node.level}`].push(id);
        node.checked = true;

        /* 仅展开直接一级子级，不越级 */
        const childKey = childKeyMap[node.level];
        if (childKey && node.childNode?.length) {
          const set = new Set(one[childKey]);
          node.childNode.forEach((c) => set.add(c));
          one[childKey] = [...set];
        }
      });
    },

    /* 以下方法全部透传，保持与原逻辑一致 */
    industrycodechange1(o) {
      this.handleToggle(o, "codechildlist1", "labelparam1", "childNode");
    },
    industrycodechangechild(o) {
      this.handleToggle(o, "childlist", "labelparam2", "childNode");
    },
    industrycodechangechil4(o) {
      this.handleToggle(o, "childlist4", "labelparam3", "childNode");
    },
    industrycodechangechil5(o) {
      this.handleToggle(o, "childcode5", "labelparam4", "childNode");
    },
    industryparamchange5(o) {
      this.handleToggle(o, "childcode6", "labelparam5", "childNode");
    },
    industryparamchange6(o) {
      this.$emit("industry-change"); // 通知父级收集
    },

    handleToggle(node, childKey, paramKey, childrenKey) {
      const one = this.industrylist[0];

      // 用 Set 保证唯一，避免重复
      const addChildren = (list) => {
        const set = new Set(one[childKey]);
        list.forEach((n) => set.add(n));
        one[childKey] = [...set]; // 追加
      };

      const removeChildren = (list) => {
        const idsToRemove = [];
        const dfs = (arr) => {
          arr?.forEach((n) => {
            idsToRemove.push(n.id);
            dfs(n.childNode);
          });
        };
        dfs(list);
        // 从数组里删除这些 id 对应的节点
        one[childKey] = one[childKey].filter(
          (n) => !idsToRemove.includes(n.id)
        );
      };

      if (!node.checked) {
        /* 勾选：追加子级 */
        if (node[childrenKey] && node[childrenKey].length) {
          addChildren(node[childrenKey]);
        }
        node.checked = true;
      } else {
        /* 取消：仅删除该父级对应的子级 */
        if (node[childrenKey] && node[childrenKey].length) {
          removeChildren(node[childrenKey]);
        }

        // 同时把该父级下的子孙 id 从所有 labelparamX 中剔除
        const idsToRemove = [];
        const dfs = (arr) => {
          arr?.forEach((n) => {
            idsToRemove.push(n.id);
            dfs(n.childNode);
          });
        };
        dfs(node[childrenKey]);
        [
          "labelparam1",
          "labelparam2",
          "labelparam3",
          "labelparam4",
          "labelparam5",
          "labelparam6",
        ].forEach((k) => {
          one[k] = one[k].filter((id) => !idsToRemove.includes(id));
        });

        node.checked = false;
      }

      this.$emit("industry-change");
    },
  },
};
</script>

<style scoped>
.child_label {
  margin-top: 15px;
}
.child_label span {
  color: #7c7f8e;
  width: 65px;
  display: inline-block;
}
</style>